import { useState, useEffect } from "react";
import ReactLoading from "react-loading";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../services/auth";

import { useGet } from "../../../reducers/useGet";

import DataTable from "react-data-table-component";
import AddButton from "../../../components/data-table-custom/add-button";
import SearchBar from "../../../components/data-table-custom/search-bar";
import { paginationComponentOptions } from "../../../components/data-table-custom/dataTableCustom";
import ErrorMessage from "../../dashboard/messages-panel/error-message";

export default function IrrigationTypeList() {
	const { access_token } = AuthService.getCurrentUser();
	let irrigationTypeList = useGet("irriga_api", access_token);

	const Navigate = useNavigate();
	const [data, setData] = useState([]);
	const [records, setRecords] = useState(data); // To be used in the SearchBar

	useEffect(() => {
		if (!irrigationTypeList.state.loading && !irrigationTypeList.state.error) {
			setData(irrigationTypeList.state.data);
			setRecords(data);
		}
	}, [
		irrigationTypeList.state.loading,
		irrigationTypeList.state.error,
		irrigationTypeList.state.data,
		data,
	]);

	const columns = [
		{ name: "ID", selector: (row) => row.id, sortable: true },
		{ name: "Nome", selector: (row) => row.nome, sortable: true },
	];

	const openIrrigationTypeDetail = (irrigationTypeData) => {
		Navigate(`/irrigation-type-list/${irrigationTypeData.id}`, {
			state: {
				irrigationTypeData,
			},
		});
	};

	return (
		<div className="page">
			{irrigationTypeList.state.loading ? (
				<div className="loading-container">
					<ReactLoading type="bubbles" color="var(--main-color)" width="50px" height="50px" />
				</div>
			) : irrigationTypeList.state.error ? (
				<ErrorMessage />
			) : (
				<div className="table-container">
					<div className="buttons-container">
						<SearchBar table={"irrigationTypes"} setRecords={setRecords} data={data} />
						<AddButton goTo={"/irrigation-type-list/add-new-irrigation-type"} />
					</div>
					<DataTable
						columns={columns}
						data={records}
						noDataComponent="Nenhum Tipo de Irrigação encontrado."
						fixedHeader
						pagination
						paginationComponentOptions={paginationComponentOptions}
						pointerOnHover={true}
						striped={true}
						onRowClicked={(irrigationTypeData) => openIrrigationTypeDetail(irrigationTypeData)}
					/>
				</div>
			)}
		</div>
	);
}
